import http from './http.js';



export function getFarmSaleRecord(farm_id,page,type){
    return http.get(`/user/farm/get_farm_sale_record/`+farm_id+'/'+type,page)
}


export function createFarmSaleRecord(farm_id,param){
    return http.post(`/user/farm/save_farm_sale_record/`+farm_id,param)
}
export function deleteFarmSaleRecord(id){
    return http.delete(`/user/farm/delete_farm_sale_record/`+id)
}